<div class="external-login-error">
  <div class="ez-alert warn">
    <mat-icon color="warn">report</mat-icon>

    @if (customErrorMessage) {
      <span class="error-text">{{ customErrorMessage }}</span>
    } @else {
      <span class="error-text">There was an error logging you in. Please
        <a href="https://www.ezlynx.com/support">contact support</a>
        if you are unable to continue to log in.
      </span>
    }
  </div>

  <div class="actions">
    @if (showForgotPassword) {
      <a class="forgot-password"
         (click)="forgotPassword()">Forgot password?</a>
    }

    <button mat-flat-button
            (click)="restartSso()"
            color="primary"
            class="restart-button">Restart SSO</button>
  </div>

  @if (supportLink) {
    <a class="support-link"
       target="blank"
       [href]="supportLink">
      SSO Help
      <mat-icon class="material-symbols-outlined">open_in_new</mat-icon>
    </a>
  }
</div>
